
/**
 * @roxi/routify 2.18.7
 * File generated Fri Apr 11 2025 09:41:28 GMT+0200 (Central European Summer Time)
 */

export const __version = "2.18.7"
export const __timestamp = "2025-04-11T07:41:28.310Z"

//buildRoutes
import { buildClientTree } from "@roxi/routify/runtime/buildRoutes"

//imports


//options
export const options = {}

//tree
export const _tree = {
  "root": true,
  "children": [
    {
      "isFallback": true,
      "path": "/_fallback",
      "component": () => import('../src/pages/_fallback.svelte').then(m => m.default)
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isDir": true,
              "ext": "",
              "children": [
                {
                  "isPage": true,
                  "path": "/aktuelles/news/:id/:url",
                  "id": "_aktuelles_news__id__url",
                  "component": () => import('../src/pages/aktuelles/news/[id]/[url].svelte').then(m => m.default)
                }
              ],
              "path": "/aktuelles/news/:id"
            }
          ],
          "path": "/aktuelles/news"
        },
        {
          "isPage": true,
          "path": "/aktuelles/news",
          "id": "_aktuelles_news",
          "component": () => import('../src/pages/aktuelles/news.svelte').then(m => m.default)
        },
        {
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isDir": true,
              "ext": "",
              "children": [
                {
                  "isPage": true,
                  "path": "/aktuelles/termine/:id/:url",
                  "id": "_aktuelles_termine__id__url",
                  "component": () => import('../src/pages/aktuelles/termine/[id]/[url].svelte').then(m => m.default)
                }
              ],
              "path": "/aktuelles/termine/:id"
            }
          ],
          "path": "/aktuelles/termine"
        },
        {
          "isPage": true,
          "path": "/aktuelles/termine",
          "id": "_aktuelles_termine",
          "component": () => import('../src/pages/aktuelles/termine.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/aktuelles/wir-wachsen",
          "id": "_aktuelles_wirWachsen",
          "component": () => import('../src/pages/aktuelles/wir-wachsen.svelte').then(m => m.default)
        }
      ],
      "path": "/aktuelles"
    },
    {
      "isPage": true,
      "path": "/datenschutz",
      "id": "_datenschutz",
      "component": () => import('../src/pages/datenschutz.svelte').then(m => m.default)
    },
    {
      "isPage": true,
      "path": "/hinweisgeberschutz",
      "id": "_hinweisgeberschutz",
      "component": () => import('../src/pages/hinweisgeberschutz.svelte').then(m => m.default)
    },
    {
      "isPage": true,
      "path": "/impressum",
      "id": "_impressum",
      "component": () => import('../src/pages/impressum.svelte').then(m => m.default)
    },
    {
      "isIndex": true,
      "isPage": true,
      "path": "/index",
      "id": "_index",
      "component": () => import('../src/pages/index.svelte').then(m => m.default)
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isPage": true,
              "path": "/karriere/:id/:url",
              "id": "_karriere__id__url",
              "component": () => import('../src/pages/karriere/[id]/[url].svelte').then(m => m.default)
            }
          ],
          "path": "/karriere/:id"
        }
      ],
      "path": "/karriere"
    },
    {
      "isPage": true,
      "path": "/karriere",
      "id": "_karriere",
      "component": () => import('../src/pages/karriere.svelte').then(m => m.default)
    },
    {
      "isPage": true,
      "path": "/kontakt",
      "id": "_kontakt",
      "component": () => import('../src/pages/kontakt.svelte').then(m => m.default)
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isPage": true,
          "path": "/loesungen/digitale-alarmierung",
          "id": "_loesungen_digitaleAlarmierung",
          "component": () => import('../src/pages/loesungen/digitale-alarmierung.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/loesungen/einsatznavigation",
          "id": "_loesungen_einsatznavigation",
          "component": () => import('../src/pages/loesungen/einsatznavigation.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/loesungen/it",
          "id": "_loesungen_it",
          "component": () => import('../src/pages/loesungen/it.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/loesungen/leitsysteme",
          "id": "_loesungen_leitsysteme",
          "component": () => import('../src/pages/loesungen/leitsysteme.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/loesungen/reparaturen",
          "id": "_loesungen_reparaturen",
          "component": () => import('../src/pages/loesungen/reparaturen.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/loesungen/sprach-und-datenfunk",
          "id": "_loesungen_sprachUndDatenfunk",
          "component": () => import('../src/pages/loesungen/sprach-und-datenfunk.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/loesungen/wachen-und-elw",
          "id": "_loesungen_wachenUndElw",
          "component": () => import('../src/pages/loesungen/wachen-und-elw.svelte').then(m => m.default)
        }
      ],
      "path": "/loesungen"
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isPage": true,
              "path": "/projekte/:id/:url",
              "id": "_projekte__id__url",
              "component": () => import('../src/pages/projekte/[id]/[url].svelte').then(m => m.default)
            }
          ],
          "path": "/projekte/:id"
        }
      ],
      "path": "/projekte"
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isPage": true,
          "path": "/ueber-uns/management",
          "id": "_ueberUns_management",
          "component": () => import('../src/pages/ueber-uns/management.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/ueber-uns/niederlassungen",
          "id": "_ueberUns_niederlassungen",
          "component": () => import('../src/pages/ueber-uns/niederlassungen.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/ueber-uns/partner",
          "id": "_ueberUns_partner",
          "component": () => import('../src/pages/ueber-uns/partner.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/ueber-uns/team",
          "id": "_ueberUns_team",
          "component": () => import('../src/pages/ueber-uns/team.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/ueber-uns/ueber-uns",
          "id": "_ueberUns_ueberUns",
          "component": () => import('../src/pages/ueber-uns/ueber-uns.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/ueber-uns/umwelt",
          "id": "_ueberUns_umwelt",
          "component": () => import('../src/pages/ueber-uns/umwelt.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/ueber-uns/unsere-werte",
          "id": "_ueberUns_unsereWerte",
          "component": () => import('../src/pages/ueber-uns/unsere-werte.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/ueber-uns/verbaende",
          "id": "_ueberUns_verbaende",
          "component": () => import('../src/pages/ueber-uns/verbaende.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/ueber-uns/zertifikate",
          "id": "_ueberUns_zertifikate",
          "component": () => import('../src/pages/ueber-uns/zertifikate.svelte').then(m => m.default)
        }
      ],
      "path": "/ueber-uns"
    }
  ],
  "isLayout": true,
  "path": "/",
  "id": "__layout",
  "component": () => import('../src/pages/_layout.svelte').then(m => m.default)
}


export const {tree, routes} = buildClientTree(_tree)

